const MANAGE_SUBSCRIPTION_PRESELECTED_STEP_MAPPER = {
  ManageBillingPeriodAnnual: 'manage_billing_period_annual',
  ManageBillingPeriod: 'manage_billing_period',
  ManagePlan: 'manage_plan',
  ChangeToSelectedPlan: 'change_to_selected_plan',
} as const;

export default MANAGE_SUBSCRIPTION_PRESELECTED_STEP_MAPPER;
